import { render, staticRenderFns } from "./ThirdPaySuc.vue?vue&type=template&id=5a0503a0&scoped=true&"
import script from "./ThirdPaySuc.vue?vue&type=script&lang=ts&"
export * from "./ThirdPaySuc.vue?vue&type=script&lang=ts&"
import style0 from "./ThirdPaySuc.vue?vue&type=style&index=0&id=5a0503a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0503a0",
  null
  
)

export default component.exports